import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ArticlesList from "@components/articles/article-list";
import CompanyTombstone from "@components/companies/tombstone";
import LockScreen from "@components/lock-screen";
import PowerBIReport from "@components/powerbi-report";
import AuthContext, { RoleType } from "@contexts/auth-context";
import { getProfileTypesData } from "@utils/helpers/profile-data";
import useWindowSize from "@utils/hooks/useWindowSize";
import classNames from "classnames";
import { useRouter } from "next/router";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { MdLock } from "react-icons/md";
var ProfileTabs = function(param) {
    var type = param.type, guestData = param.guestData, encodedName = param.encodedName, profileName = param.profileName, profileData = param.profileData, tombstoneComponents = param.tombstoneComponents;
    var _a, _b;
    var currentUser = useContext(AuthContext);
    var isBCIQOrAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.customClaims.isBCIQ) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.customClaims.roles.includes(RoleType.Admin));
    var router = useRouter();
    var tabParam = router.query.activeTab;
    var ref = useState(null), profileTypesData = ref[0], setProfileTypesData = ref[1];
    var ref1 = useState(null), activeTab = ref1[0], setActiveTab = ref1[1];
    var width = useWindowSize().width;
    var selectTab = useCallback(function(tab) {
        if (tab) {
            router.push("/".concat(type, "/").concat(encodedName, "?activeTab=").concat(tab === null || tab === void 0 ? void 0 : tab.name), undefined, {
                shallow: true
            });
        }
    }, [
        encodedName,
        router,
        type
    ]);
    useEffect(function() {
        if (width) {
            setProfileTypesData(getProfileTypesData({
                type: type,
                archived: profileData === null || profileData === void 0 ? void 0 : profileData.archived,
                companyType: profileData === null || profileData === void 0 ? void 0 : profileData.companyType,
                isLoggedIn: !!currentUser,
                dimension: profileData === null || profileData === void 0 ? void 0 : profileData.dimension,
                isMobile: width < 640
            }));
        }
    }, [
        width,
        tabParam,
        currentUser,
        profileName,
        profileData === null || profileData === void 0 ? void 0 : profileData.archived,
        profileData === null || profileData === void 0 ? void 0 : profileData.companyType,
        type,
        profileData === null || profileData === void 0 ? void 0 : profileData.dimension, 
    ]);
    useEffect(function() {
        if (profileTypesData === null || profileTypesData === void 0 ? void 0 : profileTypesData.tabs) {
            var defaultTab = tabParam ? profileTypesData.tabs.find(function(param) {
                var name = param.name;
                return name === tabParam;
            }) : null;
            setActiveTab(defaultTab !== null && defaultTab !== void 0 ? defaultTab : profileTypesData === null || profileTypesData === void 0 ? void 0 : profileTypesData.tabs[0]);
        }
    }, [
        profileTypesData === null || profileTypesData === void 0 ? void 0 : profileTypesData.tabs,
        tabParam
    ]);
    var showLockScreen = useCallback(function() {
        return (activeTab === null || activeTab === void 0 ? void 0 : activeTab.isLocked) && !isBCIQOrAdmin;
    }, [
        activeTab,
        currentUser
    ]);
    var showTombStone = useCallback(function() {
        return (activeTab === null || activeTab === void 0 ? void 0 : activeTab.showTombstone) && (profileData === null || profileData === void 0 ? void 0 : profileData.tombstone);
    }, [
        activeTab,
        profileData === null || profileData === void 0 ? void 0 : profileData.tombstone
    ]);
    var tabHeader = useMemo(function() {
        var _a;
        return ((_a = profileTypesData === null || profileTypesData === void 0 ? void 0 : profileTypesData.tabs) !== null && _a !== void 0 ? _a : []).map(function(tab, index) {
            var name = tab.name, displayName = tab.displayName, isLocked = tab.isLocked;
            var showLockIcon = isLocked && !isBCIQOrAdmin;
            return /*#__PURE__*/ _jsxs("div", {
                className: classNames([
                    "items-center flex py-1 cursor-pointer px-2 text-sm font-bold hover:underline hover:bg-white hover:text-altPrimary whitespace-nowrap",
                    {
                        "bg-white text-altPrimary underline": name === (activeTab === null || activeTab === void 0 ? void 0 : activeTab.name)
                    },
                    {
                        "mx-2": index > 0
                    },
                    {
                        "mr-2": index === 0
                    }, 
                ]),
                onClick: function() {
                    return selectTab(tab);
                },
                children: [
                    showLockIcon && /*#__PURE__*/ _jsx(MdLock, {
                        className: "mr-1"
                    }),
                    displayName
                ]
            }, name);
        });
    }, [
        activeTab === null || activeTab === void 0 ? void 0 : activeTab.name,
        currentUser,
        profileTypesData === null || profileTypesData === void 0 ? void 0 : profileTypesData.tabs,
        selectTab
    ]);
    var isAgentBot = /prerender|twitterbot|linkedinbot|applebot|bot|googlebot|crawler|spider|robot|crawling/.test(navigator.userAgent.toLowerCase());
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                className: "bg-altPrimary mt-4 flex-shrink flex text-white uppercase pl-4 w-full overflow-x-auto items-center",
                children: tabHeader
            }),
            activeTab && /*#__PURE__*/ _jsxs("div", {
                className: "bg-gray-200",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "p-4 flex flex-col items-center justify-center",
                        children: [
                            showLockScreen() && /*#__PURE__*/ _jsx(LockScreen, {
                                data: guestData
                            }),
                            showTombStone() && /*#__PURE__*/ _jsx(CompanyTombstone, {
                                companyData: profileData,
                                tombstoneComponents: tombstoneComponents
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames([
                            "px-4",
                            {
                                hidden: (profileData === null || profileData === void 0 ? void 0 : profileData.archived) || showLockScreen() || !!!(activeTab === null || activeTab === void 0 ? void 0 : activeTab.sectionName)
                            }, 
                        ]),
                        children: !isAgentBot && /*#__PURE__*/ _jsx(PowerBIReport, {
                            column: profileTypesData.column,
                            profileName: profileName,
                            reportId: profileTypesData.reportId,
                            sectionTab: activeTab,
                            table: profileTypesData.table,
                            type: type,
                            workspaceId: profileTypesData.workspaceId,
                            customLayout: width >= 640
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "bg-gray-200 mb-5 grid grid-cols-1 items-center justify-center p-4",
                        children: /*#__PURE__*/ _jsx(ArticlesList, {
                            profileName: (_b = (_a = profileData === null || profileData === void 0 ? void 0 : profileData.code) !== null && _a !== void 0 ? _a : profileData === null || profileData === void 0 ? void 0 : profileData.searchBy) !== null && _b !== void 0 ? _b : profileName,
                            type: type
                        })
                    })
                ]
            })
        ]
    });
};
export default ProfileTabs;
